import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';

export default {
  name: 'SelectSewer',
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      sewer: {
        townId: -1,
        townStr: '',
        townshipId: -1,
        townshipStr: '',
        connectionName: '',
        connectionId: null,
        connectionNumber: '',
        customerKey: '',
        propertyReference: '',
        isSelected: false
      },
      searchTownId: -1,
      searchTownStr: '',
      searchTownshipId: -1,
      searchTownshipStr: '',
      searchConnectionName: '',
      searchConnectionId: null,
      searchConnectionNumber: '',
      searchCustomerKey: '',
      searchPropertyReference: '',
      keyColumn: 'connectionId',
      connections: [],
      currentConnections: [],
      towns: [],
      townSelected: -1,
      townships: [],
      townshipSelected: -1,
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      message: '',
      lang: '',
      connectionsCols: [],
      isReadOnly: false,
      noDataFound: false,
      filterBy: [
        { value: 1, title: "Tenant", show: true },
        { value: 2, title: "Active", show: false },
        { value: 3, title: "Owner", show: true },
        { value: 4, title: "VolDisconnected", show: false }
      ],
    }
  },
  computed: {
    isSewerSelected: function () {
      return this.sewer.connectionId > 0;
    },
    sewerId: function () {
      return this.sewer.sewerId;
    },
  },
  watch: {
    sewerId: function () {
      //this.customer.fullName = this.customer.initial.length > 0 ? this.customer.initial + ' ' + this.customer.surname : this.customer.surname;
    }
  },
  created() {
    this.$root.$on('select_sewer_updated', this.init);
    this.fillConnectionsCols();
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.sewer = this.dataObj.sewer;
        this.towns = this.dataObj.towns;
        this.townships = this.dataObj.townships;
        this.isReadOnly = this.dataObj.isReadOnly;
        this.getCurrentSewerConnections();
        this.getSewerConnections();
      });
    },
    pageChange(pInfo) { 
      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getSewerConnections();
    },
    fullCustName() {
      //return this.customer.initial.length > 0 ? this.customer.initial + ' ' + this.customer.surname : this.customer.surname;
    },
    getCurrentSewerConnections() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/SelectSewerConnectionActivity/GetCurrentSewerConnections', parameter),
        response => {
          if (response.status == 200) {
            this.currentConnections = response.data.items;
            if (this.currentConnections.length > 0) {
              var prop = this.currentConnections[0];
              this.sewer.townId = prop.townId;
              this.sewer.townStr = prop.townStr;
              this.sewer.townshipId = prop.townshipId;
              this.sewer.townshipStr = prop.townshipStr;
              this.sewer.connectionName = prop.connectionName;
              this.sewer.connectionId = prop.connectionId;
              this.sewer.connectionNumber = prop.connectionNumber;
              this.sewer.customerKey = prop.customerKey;
              this.sewer.propertyReference = prop.propertyReference;
              this.sewer.isSelected = prop.isSelected;
            }
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/SelectSewerConnectionActivity/GetCurrentSewerConnections', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.currentConnections = response.data.items;
      //      if (this.currentConnections.length > 0) {
      //        var prop = this.currentConnections[0];
      //        this.sewer.townId = prop.townId;
      //        this.sewer.townStr = prop.townStr;
      //        this.sewer.townshipId = prop.townshipId;
      //        this.sewer.townshipStr = prop.townshipStr;
      //        this.sewer.connectionName = prop.connectionName;
      //        this.sewer.connectionId = prop.connectionId;
      //        this.sewer.connectionNumber = prop.connectionNumber;
      //        this.sewer.customerKey = prop.customerKey;
      //        this.sewer.propertyReference = prop.propertyReference;
      //        this.sewer.isSelected = prop.isSelected;
      //      }
      //    }
      //    else
      //      this.$alertMsg(response.data.data.text, 1);
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.statusText);
      //  });
    },
    getSewerConnections() {
      var criteria = {
        townId: this.townSelected,
        townStr: '',
        townshipId: this.townshipSelected,
        townshipStr: '',
        connectionName: this.searchConnectionName,
        connectionId: this.searchConnectionId,
        connectionNumber: this.searchConnectionNumber,
        customerKey: this.searchCustomerKey,
        propertyReference: this.searchPropertyReference,
        isSelected: false
      };
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Filters: criteria,
        Options: this.options
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/SelectSewerConnectionActivity/GetSewerConnections', parameter),
        response => {
          if (response.status == 200) {
            console.log(response.data);
            this.ResultColumns = [];
            let keys = Object.keys(Object.assign({}, ...response.data.items));

            for (let i = 0; i < keys.length; i++) {
              this.ResultColumns.push({ dataField: keys[i], caption: this.$t('activities.' + keys[i]) == 'activities.' + keys[i] ? keys[i] : this.$t('activities.' + keys[i]) });
            }

            if (response.data.items.length == 0) {
              this.connections = [];
              this.noDataFound = true;
            }
            else {
              this.connections = response.data.items;
              this.options.total = response.data.itemsCount;
              this.totalRow = response.data.itemsCount;
            }
            this.$root.$emit('datagrid_updated');
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/SelectSewerConnectionActivity/GetSewerConnections', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      console.log(response.data);
      //      this.ResultColumns = [];
      //      let keys = Object.keys(Object.assign({}, ...response.data.items));

      //      for (let i = 0; i < keys.length; i++) {
      //        this.ResultColumns.push({ dataField: keys[i], caption: this.$t('activities.' + keys[i]) == 'activities.' + keys[i] ? keys[i] : this.$t('activities.' + keys[i]) });
      //      }

      //      if (response.data.items.length == 0) {
      //        this.connections = [];
      //        this.noDataFound = true;
      //      }
      //      else {
      //        this.connections = response.data.items;
      //        this.options.total = response.data.itemsCount;
      //        this.totalRow = response.data.itemsCount;
      //      }
      //      this.$root.$emit('datagrid_updated');
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text, 1);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.statusText);
      //  });
    },
    selectSewerConnection() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        SewerConnectionID: this.sewer.connectionId,
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/SelectSewerConnectionActivity/SelectSewerConnection', parameter),
        response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.SelectSewerSuccess'), 2);
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/SelectSewerConnectionActivity/SelectSewerConnection', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.$alertMsg(this.$t('messages.SelectSewerSuccess'), 0);
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text, 1);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.statusText);
      //  });
    },
    selectSewerConnections() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        SewerConnectionIDs: [],
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/SelectSewerConnectionActivity/SelectSewerConnections', parameter),
        response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.SelectSewerSuccess'), 2);
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/SelectSewerConnectionActivity/SelectSewerConnections', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.$alertMsg(this.$t('messages.SelectSewerSuccess'), 0);
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text, 1);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.data);
      //  });
    },
    resetFilters() {
      this.searchTownId = -1;
      this.searchTownStr = '';
      this.searchTownshipId = -1;
      this.searchTownshipStr = '';
      this.searchConnectionName = '';
      this.searchConnectionId = -1;
      this.searchConnectionNumber = '';
      this.searchCustomerKey = '';
      this.searchTenantName = '';
      this.searchPropertyReference = '';
    },
    onSelectSewer(info) {
      var prop = info.data;
      if ((prop === null) || (prop === undefined))
        return;

      this.sewer.townId = prop.townId;
      this.sewer.townStr = prop.townStr;
      this.sewer.townshipId = prop.townshipId;
      this.sewer.townshipStr = prop.townshipStr;
      this.sewer.connectionName = prop.connectionName;
      this.sewer.connectionId = prop.connectionId;
      this.sewer.connectionNumber = prop.connectionNumber;
      this.sewer.customerKey = prop.customerKey;
      this.sewer.propertyReference = prop.propertyReference;
      this.sewer.isSelected = true

      //this.selectSewerConnection();
    },
    fillConnectionsCols() {
      this.connectionsCols.push({ dataField: 'propertyReference', caption: this.$t('activities.propertyReference') });
      this.connectionsCols.push({ dataField: 'connectionNumber', caption: this.$t('activities.conn') });
      this.connectionsCols.push({ dataField: 'customerKey', caption: this.$t('activities.tenantAccount') });
    }
  },
  
}

